import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

export const Ewallet = (props: IIconProps) => (
  <Icon viewBox="0 0 28 28" {...props}>
    <Path
      d="M24.737 8.06a47.95 47.95 0 0 0 0-4.619 1.725 1.725 0 0 0-.445-1.094 1.336 1.336 0 0 0-.946-.52A90.636 90.636 0 0 0 3.942 4.276a1.67 1.67 0 0 0-1.057.798A49.547 49.547 0 0 0 1.03 20.322a3.951 3.951 0 0 0 2.3 3.135 45.04 45.04 0 0 0 17.79 2.652 3.895 3.895 0 0 0 3.116-2.318A49.788 49.788 0 0 0 27 10.917a3.042 3.042 0 0 0-2.263-2.857ZM9.897 5.52A91.303 91.303 0 0 1 22.529 4.33c0 1.04-.11 2.097-.185 3.154A104.644 104.644 0 0 0 9.878 5.519h.019Zm14.005 11.909a2.245 2.245 0 1 1-1.855-2.541 2.226 2.226 0 0 1 1.837 2.541h.018Z"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </Icon>
);

export default Ewallet;
